<template>
  <div class="loading-page">
    <div class="img-box">
      <img :src="require('../../assets/images/loading.svg')" alt="">
    </div>
  </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/layout/loading.vue